export default function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div
      className="panel-header px-6 lg:px-8 py-5 flex items-start justify-between gap-4 flex-wrap scan-line"
      data-testid={testId}
    >
      <div>
        <div className="label-mono">// {subtitle || "Constructora ERP"}</div>
        <h1 className="font-display font-black text-2xl sm:text-3xl tracking-wide mt-1 text-slate-100">
          {title}
        </h1>
      </div>
      {actions && <div className="flex gap-2 items-center">{actions}</div>}
    </div>
  );
}

export function StatusBadge({ items, value, testId }) {
  const item =
    items.find((i) => i.value === value) || { label: value, color: "badge-mute" };
  return (
    <span
      data-testid={testId}
      className={`px-2 py-0.5 text-[10px] font-semibold rounded-sm inline-flex items-center uppercase tracking-widest ${item.color}`}
    >
      {item.label}
    </span>
  );
}
